import axios from "axios";

const instance = axios.create({
  // baseURL: "https://heatmapapi.onrender.com",
  // baseURL: "https://api.vsfintech.in",
  baseURL: "https://apivsfintech.invtechnologies.in/",
  
});

export default instance;
